// extracted by mini-css-extract-plugin
export default {"container":"list-roles_container__XN5Y4","content":"list-roles_content__DXpsz","status":"list-roles_status__IQGq3"};